import { render, staticRenderFns } from "./CopyOrderSettings.vue?vue&type=template&id=697f0872&scoped=true&"
import script from "./CopyOrderSettings.vue?vue&type=script&lang=js&"
export * from "./CopyOrderSettings.vue?vue&type=script&lang=js&"
import style0 from "./CopyOrderSettings.vue?vue&type=style&index=0&id=697f0872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f0872",
  null
  
)

/* custom blocks */
import block0 from "./CopyOrderSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports